import { BMotionType } from './BMotionEnums';
import { Point, NumberUtils } from '../Misc/Utils';
import { Constants } from '../Misc/Constants';
import { Easing } from '../Graphics/Easing';
import { KeyFrame } from '../KeyFrame/KeyFrame';
import { BMotionLabel } from '../BMotionCharacterisitics/BMotionLabels';
import { KeyFramesHolder } from '../KeyFrame/KeyFramesHolder';

export abstract class BMotion2{
    abstract readonly TYPE : BMotionType

    private _keyFrames : KeyFramesHolder = new KeyFramesHolder();
    get keyFrames(): KeyFramesHolder{
        return this._keyFrames;
    }

    protected _loop: boolean = true
    get loop(): boolean {
        return this._loop;
    }
    set loop(tloop: boolean){
        this._loop = tloop;
    }

    protected _easeIn: boolean = true
    get easeIn(): boolean {
        //console.log("ret easein "+this._easeIn);
        return this._easeIn;
    }
    set easeIn(ease: boolean){
        console.log("set easein "+ease);
        this._easeIn = ease;
    }

    protected _easeOut: boolean = true
    get easeOut(): boolean {
        //console.log("ret easeout "+this._easeOut);
        return this._easeOut;
    }
    set easeOut(ease: boolean){
        console.log("set easeout "+ease);
        this._easeOut = ease;
    }

    protected _computedVal: Array<number> = [0]
    get computedVal(): Array<number>{
        return this._computedVal;
    }

    //protected _totalMotionFrames : number = 0
    get totalMotionFrames(): number {
        return this._keyFrames.getMaxKeyFrame();
    }

    protected isComplete: boolean = false;
    

    constructor(){
    }

    //Called just before animation starts
    //Do all clean up work if necessary
    prepare(){
        this.reset();
    }

    reset(){
        //console.log("resetting...");
        if(this.keyFrames.size() > 0){
            this.resetComputedVal();   
        }else{
            this._computedVal = Constants.ORIGIN;
        }
        this.isComplete = false;
    }

    protected resetComputedVal(){
        this._computedVal = Constants.ORIGIN;
    }

    update(globalCurFrame: number): void{
        if(this.canAnimate()){
            var frame = this.getLocalFrame(globalCurFrame);
            //var [prev,next] = this.getKeyFrames(frame);
            var [prev,next] = [this.keyFrames.getPrev(frame), this.keyFrames.getNext(frame)];
            if(prev!=undefined && next!=undefined){
                var interpolant = this.calcInterpolant(frame, prev, next);
                this._computedVal = this.interpolate(interpolant, prev, next);
            }else{
                //!!! Should never happen
                console.log("Keyframe prev and next UNDEFINED. global frame:"+globalCurFrame+" local frame:"+frame);
                this.keyFrames.printKeys();
            }
            //console.log("val:"+this.computedVal+" ip:"+interpolant+" f:"+frame);
        }
    }

    private getLocalFrame(curFrame: number): number{
        var frame = curFrame;
        if(this.loop){
            frame = curFrame % (this.totalMotionFrames+1);
        }else{
            frame = NumberUtils.fitToRange(curFrame, 0, this.totalMotionFrames);
        }

        if(this.easeIn || this.easeOut){
            frame = this.applyEaseInEaseOut(frame, 0, this.totalMotionFrames)
        }

        return frame;
    }

    /*private getKeyFrames(frame: number): [KeyFrame, KeyFrame]{
        var len = this.keyFrames.size() - 1;
        var lastIndex = 0;
        for(let i = 0; i < len ; i++){
            if(frame >= this.keyFrames[i].frame && frame <= this.keyFrames[i+1].frame){
                lastIndex = i;
                break;
            }
        }
        //lastIndex+1 is guaranteed to be less than this.keyFrames.length since we len is lenght-1
        return [this.keyFrames[lastIndex], this.keyFrames[lastIndex+1]];
    }*/

    protected abstract interpolate(interpolant: number, prevKeyFrame: KeyFrame, nextKeyFrame: KeyFrame) : Array<number>;

    private calcInterpolant(frame: number, prev: KeyFrame, next: KeyFrame): number{
        return (frame - prev.frame)/(next.frame - prev.frame)
    }

    private applyEaseInEaseOut(cur: number, start: number, end: number): number{
        var scaled = (cur-start)/(end-start);
        var eased = 0;
        if(this.easeIn && this.easeOut){
            eased = Easing.Functions.easeInOutQuad(scaled);
        }else if(this.easeIn){
            eased = Easing.Functions.easeInQuad(scaled);
        }else if(this.easeOut){
            eased = Easing.Functions.easeOutQuad(scaled);
        }
        return (eased*(end-start))+start;
    }

    /*updat1e(globalCurFrame: number): void {
        if(this.hasKeyFrames() && !this.isComplete){
            let nextKeyFrameIndex = NumberUtils.fitToRange(
                this.lastKeyFrameIndex+1, 0, this.keyFrames.length-1)
            let prevKeyFrameIndex = NumberUtils.fitToRange(
                this.lastKeyFrameIndex, 0, this.keyFrames.length-1);

            let interpolant = this.calcInterpolant(globalCurFrame, this.keyFrames[nextKeyFrameIndex]);
            
            this._computedVal = this.interpolate(interpolant, prevKeyFrameIndex, nextKeyFrameIndex);

            this.postUpdate(interpolant, globalCurFrame);
        }
    }*/

    /*calcInterpolant(curGlobalFrame: number, nextKeyFrameDetails: KeyFrame) : number{
        var frame = curGlobalFrame;
        if(this.loop){
            frame = curGlobalFrame  % (this.totalMotionFrames+1);
        }

        let interpolant = (frame - this.lastKeyFrame) / nextKeyFrameDetails.frameGap;
        console.log("interpolant: "+ interpolant
                    +" curFrame:"+ curGlobalFrame
                    +" frame:"+ frame
                    +" tmf:" + this.totalMotionFrames
                    +" lkf:" + this.lastKeyFrame
                    +" fg:" + nextKeyFrameDetails.frameGap);
        return interpolant;
    }

    private postUpdate(interpolant: number, globalCurFrame: number){
        if(interpolant >= 1){
            if(this.lastKeyFrameIndex < this.keyFrames.length){
                this.lastKeyFrameIndex++;
                this.lastKeyFrame = globalCurFrame;
                console.log("lkfi:"+this.lastKeyFrameIndex+" lkf"+this.lastKeyFrame+" len:"+this.keyFrames.length);
                if(!this.loop && this.lastKeyFrameIndex == this.keyFrames.length-1){
                    this.isComplete = true;
                }else if(this.loop && this.lastKeyFrameIndex == this.keyFrames.length-1){
                    this.reset();
                }
            }
        }
    }*/

    public canAnimate(): boolean {
        return this.keyFrames.size() > 1
    }

    public updatePropertyValue(name: BMotionLabel, val: any){
        console.log("updating "+name+" "+val);
        switch(name){
            case BMotionLabel.LOOP:
                this.loop = val as boolean
                break;
            case BMotionLabel.EASEIN:
                this.easeIn = val as boolean
                break;
            case BMotionLabel.EASEOUT:
                this.easeOut = val as boolean
                break;
        }
    }

    public updateKeyFrame(frameNumber: number,  newValue: Array<number>): void{
        //console.log("updating key frame: "+frameNumber+" val:"+newValue);
        if(Number(frameNumber)!=NaN){
            if(this.keyFrames.contains(frameNumber)){
                this.updateKeyFrameVal(frameNumber, newValue);
            }else{
                this.createNewKeyFrame(frameNumber, newValue);
            }
        }
    }

    /**
     * Call this method to clear all key frames. 
     * A motion should always have the first key frame.
     */
    public clearAllKeyFrames(){
        this.keyFrames.clearAllExceptFirst();
    }

    public replaceKeyFrame(originalKeyFrame: number, newKeyFrame : number){
        if(Number(originalKeyFrame)!=NaN && Number(newKeyFrame)!=NaN && this.keyFrames.contains(originalKeyFrame)){
            var keyFrameVal = this.keyFrames.get(originalKeyFrame);
            this.keyFrames.remove(originalKeyFrame);
            if(keyFrameVal){
                keyFrameVal.frame = newKeyFrame;
                this.keyFrames.add(newKeyFrame, keyFrameVal);
            }
        }
    }

    /*private hasKeyFrame(frameNumber: number): boolean{
        for(let keyFrame of this.keyFrames){
            if(keyFrame.frame == frameNumber){
                return true;
            }
        }
        return false;
    }*/

    protected abstract updateKeyFrameVal(frameNumber: number, newValue: Array<number>): void;

    protected abstract createNewKeyFrame(frameNumber: number, newValue: Array<number>): void;

    abstract clone(): BMotion2;

    protected duplicate(clone: BMotion2){
        clone.loop = this.loop;
        clone.easeIn = this.easeIn;
        clone.easeOut = this.easeOut;
    }

    drawControl(canvasCtx: CanvasRenderingContext2D): void {

    }
    checkControlPointSelection(pointRelToCentre: Point): boolean {
        return false;
    }
    editControlPoint(curMousePointRelToCentre: Point): void {
    
    }
    getIsControlPointSelected(): boolean {
        return false;
    }
    setIsControlPointSelected(isSelected: boolean): void {

    }
    
}